import { Component, ElementRef, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'spinner',
    template: `@if (show) {<div class="spinner-mask"><div class="spinner"></div></div>}`,
    standalone: false
})
export class SpinnerComponent implements OnInit, OnDestroy {

    public show: boolean = false;
    private subscription: Subscription = null;

    constructor(private spinnerService: SpinnerService, private changeDetector: ChangeDetectorRef) {}

    ngOnInit() {
       this.createServiceSubscription();
    }

    private createServiceSubscription() {
        this.subscription = this.spinnerService.spinnerObservable.subscribe(show => {
            if (show) {
                this.showSpinner();
            } else {
                this.hideSpinner();
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private showSpinner() {
        this.show = true;
        this.changeDetector.detectChanges();
    }

    private hideSpinner() {
        this.show = false;
        this.changeDetector.detectChanges();
    }
}